import { handleActions } from 'redux-actions'
import { Record } from 'immutable'

import { setStepIndex } from './actions'

class Tour extends Record({
  stepIndex: 0,
}) {}

const handleSetStepIndex = (state, { payload }) => {
  return state.set('stepIndex', payload)
}

export default handleActions(
  {
    [setStepIndex.toString()]: handleSetStepIndex,
  },
  new Tour()
)
